"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = void 0;
exports.snacks = snacks;
var actions = _interopRequireWildcard(require("../actions"));
var _sanitizer = require("../utils/sanitizer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const initialState = exports.initialState = {
  entities: []
};
const validateNotificationDelay = notification => {
  const {
    customData = {},
    delay
  } = notification;
  if (customData.delay !== undefined) {
    return Number(customData.delay);
  }
  if (delay !== undefined) {
    return Number(delay);
  }
  return undefined;
};
const unifySnackFormat = notification => {
  let formatedActions = [];
  if (notification.actions) {
    formatedActions = notification.actions.map(action => {
      if (!action.extra && !action.callback) {
        return {
          title: action.title,
          extra: {
            uri: (0, _sanitizer.sanitizeHref)(action.uri),
            newTab: action.newTab
          }
        };
      }
      return action;
    });
  }
  return {
    ...notification,
    actions: formatedActions,
    delay: validateNotificationDelay(notification)
  };
};
function snacks(state = initialState, action) {
  switch (action.type) {
    case actions.SET_SNACK:
      {
        const foundEntity = state.entities.find(entity => entity.ID === action.payload.ID);
        if (foundEntity) {
          return {
            ...state,
            entities: state.entities.map(entity => {
              return entity.ID === action.payload.ID ? {
                ...entity,
                ...action.payload
              } : entity;
            })
          };
        }
        return {
          ...state,
          entities: [...state.entities, unifySnackFormat(action.payload)]
        };
      }
    case actions.CLEAR_SNACK:
      return {
        ...state,
        entities: state.entities.filter(entity => entity.ID !== action.payload.ID)
      };
    case actions.CHANGE_SNACK:
      return {
        ...state,
        entities: state.entities.map(entity => {
          return entity.ID === action.payload.ID ? {
            ...entity,
            ...action.payload
          } : entity;
        })
      };
    default:
      return state;
  }
}